export default {
    country: 'Country',
    noCountry: 'Country not found',
    noCountries: 'Countries not found',
    countryPlaceHolder: 'Select a country',
};